/**
 * Microsoft Clarity — client component.
 *
 * Injects the Clarity tracking snippet **only** when a valid
 * `NEXT_PUBLIC_CLARITY_ID` env var is provided (production builds).
 */
'use client';

import Script from 'next/script';

const CLARITY_ID = process.env.NEXT_PUBLIC_CLARITY_ID;

export function MicrosoftClarity() {
  if (!CLARITY_ID) return null;

  return (
    <Script id="clarity-script" strategy="lazyOnload">
      {`(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", '${CLARITY_ID}');`}
    </Script>
  );
}
